module.exports = __webpack_public_path__ + "img/AF9A72_504718_74652B_E2C2A2-256px.ff83e808.png";